import React, { FC } from "react"
import L10n from "lib/carrot-l10n"
import { Body, H2, FlexContainer, Container } from "@carrotfertility/carotene"
import { Steps } from "../workflow/steps"
import { useStateMachine } from "../../context/stateMachine/StateMachineContext"
import { useProgressTracker } from "../../views/modal/ProgressTracker"
import { IlloPercentCircle } from "../../views/atoms/Illustrations"
import { BenefitEnrollmentModalContinueButton } from "../shared"
import { useBenefitEnrollment } from "../../context/enrollment/BenefitEnrollmentContext"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()
const ViewName = Steps.INTRO_INFORMATIONAL

const IntroToInsuranceFlow: FC = () => {
  const { needsBenefitEnrollment } = useBenefitEnrollment()
  const { setNextStep } = useStateMachine(ViewName, null)

  const { hideProgress } = useProgressTracker()
  hideProgress()

  return (
    <div>
      <FlexContainer justifyContent="center" padding="none" stack="medium">
        <IlloPercentCircle />
      </FlexContainer>
      <H2 variant="primary" stack="small">{l`To access your Carrot funds, tell us about your health insurance`}</H2>
      <Container padding="none" stack="medium">
        <Body color="black-80">
          {l`We're asking about your insurance coverage because it affects how your Carrot funds are taxed and if a 
          deductible applies. If you're on this journey with a partner, we'll need information about their coverage too. 
          You may want to have your insurance card(s) nearby.`}
        </Body>
      </Container>
      <Container padding="none" stack="medium">
        <Body color="black-80">
          {l`If we determine you and/or your partner have a deductible, it needs to be met before we can reimburse 
          qualified medical expenses — the kind the IRS doesn't tax. Other types of expenses can be reimbursed right away.`}
        </Body>
      </Container>
      <Container padding="none" stack="huge">
        <Body color="black-80">
          {l`Note: The accuracy of your answers may have legal and financial implications, so if there's something 
          you're not sure about, please check with your insurance provider, benefits portal, and/or HR department.`}
        </Body>
      </Container>
      <BenefitEnrollmentModalContinueButton
        onClick={() => setNextStep(ViewName, needsBenefitEnrollment ? "" : "SKIP_THIS_FLOW")}
      />
    </div>
  )
}

export { IntroToInsuranceFlow }
